<ng-template #step1>
  <div class="dialog__body dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey">
    <div class="dialog__port-rule">
      <div class="dialog__port-number">{{ sapIndex() + 1 }}</div>
      <div class="dialog__port-text">{{ portDescription() }}</div>
    </div>
    <div class="dialog__inner">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="dialog__label">{{ "Selfservice.BFD.Label.Activate" | translate }}</div>
          <div class="selfservice-bfd__toggle">
            <input
              id="toggle-bfd"
              type="checkbox"
              [(ngModel)]="bfdActivated"
              [value]="true"
              (change)="handleChange()"
            />
            <label for="toggle-bfd">
              <selfservice-toggle [active]="bfdActivated()"></selfservice-toggle>
              <div [class.blue]="bfdActivated()">{{ bfdActivated() }}</div>
            </label>
          </div>
        </div>
      </div>
      <div [class.disabled]="!bfdActivated()" class="selfservice-bfd__extra-fields">
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="dialog__label">{{ "Selfservice.BFD.Label.TimeInterval" | translate }}</div>
            <div class="input__wrapper">
              <input
                type="number"
                class="input input--shadow"
                placeholder="450"
                min="300"
                max="10000"
                [(ngModel)]="timeInterval"
                [class.input--witherror]="!validTimeInterval() && bfdActivated()"
              />
              <div class="input__addon">ms</div>
              @if (!validTimeInterval() && bfdActivated()) {
                <div class="input__error">
                  {{ "Selfservice.BFD.Error.TimeInterval" | translate }}
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="dialog__label">{{ "Selfservice.BFD.Label.Multiplier" | translate }}</div>
            <div class="input__wrapper">
              <input
                type="number"
                class="input input--shadow"
                placeholder="3"
                [(ngModel)]="multiplier"
                [class.input--witherror]="!validMultiplier() && bfdActivated()"
              />
              @if (!validMultiplier() && bfdActivated()) {
                <div class="input__error">
                  {{ "Selfservice.BFD.Error.Multiplier" | translate }}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="dialog__bottom-message">
    <div class="dialog__bottom-message-inner">
      <svg-icon src="assets/images/icons/status-failure.svg" class="dialog__bottom-message-icon"></svg-icon>
      <span> {{ "Selfservice.BFD.Message" | translate }} </span>
    </div>
  </div>
</ng-template>

<ng-template #step2>
  <div class="dialog__body dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey">
    <div class="dialog__port-rule">
      <div class="dialog__port-number">{{ sapIndex() + 1 }}</div>
      <div class="dialog__port-text">{{ portDescription() }}</div>
    </div>
    <div>
      <div class="dialog__inner">
        <h3 class="dialog__sub-heading">{{ "Selfservice.Global.Title" | translate }}</h3>
        <p class="no-margin">{{ "Selfservice.BFD.Text" | translate }}</p>
      </div>

      <div class="dialog__rule">
        <h3 class="dialog__sub-heading">{{ "Selfservice.Global.CurrentSetting" | translate }} BFD</h3>
        <div class="dialog__rule-answer">
          {{ instance().bfd }}
          @if (instance().bfd && instance().bfdMinimumInterval) {
            <span>/ {{ instance().bfdMinimumInterval }}</span>
          }
          @if (instance().bfd && instance().bfdMultiplier) {
            <span>/ {{ instance().bfdMultiplier }}</span>
          }
        </div>
      </div>
      <div class="dialog__rule">
        <h3 class="dialog__sub-heading">{{ "Selfservice.Global.NewSetting" | translate }} BFD</h3>
        <div class="dialog__rule-answer blue">
          {{ bfdActivated() }}
          @if (bfdActivated()) {
            <span>/ {{ timeInterval() }} / {{ multiplier() }}</span>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<selfservice-wizard [steps]="[step1, step2]" [getCommand]="buildCommand" [bus]="bus()" [canContinue]="canContinue()" />
